import React from 'react';
import { cn } from '../classname';
import { ToolbarButtonGroup } from './ToolbarGroup';
import './Toolbar.css';
const b = cn('toolbar');
export function Toolbar({ editor, data, className, focus, onClick }) {
    return (React.createElement("div", { className: b(null, [className]) }, data.map((group, index) => {
        const isLastGroup = index === data.length - 1;
        return (React.createElement(React.Fragment, { key: index },
            React.createElement(ToolbarButtonGroup, { data: group, editor: editor, focus: focus, onClick: onClick, className: b('group') }),
            isLastGroup || React.createElement("div", { className: b('group-separator') })));
    })));
}
